import { OrganizationKeyName } from "../../../../model/Organization";

export const GET_USER_VOUCHER_LIST = "SHOP:GET_USER_VOUCHER_LIST";

export const getUserVoucherListAction = (
  organization: OrganizationKeyName,
  userId: string,
  filters: any
) => ({
  type: GET_USER_VOUCHER_LIST as typeof GET_USER_VOUCHER_LIST,
  organization,
  userId,
  filters,
});

export type GetUserVoucherListAction = ReturnType<
  typeof getUserVoucherListAction
>;
